import { GraphQLEnumType } from 'graphql';

module.exports = new GraphQLEnumType({
  name: 'CompletionStatusEnum',
  values: {
    COMPLETE: {
      value: 'COMPLETE'
    },
    IN_COMPLETE: {
      value: 'IN_COMPLETE'
    },
    NOT_ATTEMPTED: {
      value: 'NOT_ATTEMPTED'
    }
  }
});
